import { useState, useRef } from 'react';
import { Button, Menu } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const ButtonWithDropdownMenu = ({
    label = '',
    buttonProps,
    menuProps,
    dropdownContent = null,
    open: controlledOpen,
    onOpen,
    onClose,
    menuHasButtonMinWidth = true,
    hideChevron = false,
}) => {
    const buttonRef = useRef(null);
    const [internalOpen, setInternalOpen] = useState(false);
    const isControlled = controlledOpen !== undefined;
    const isOpen = isControlled ? controlledOpen : internalOpen;
    const menuId = menuProps?.id || label.toLowerCase().replace(/\s+/g, '-').concat('-menu');

    const handleOpen = () => {
        if (!isControlled) setInternalOpen(true);
        onOpen?.();
    };

    const handleClose = () => {
        if (!isControlled) setInternalOpen(false);
        onClose?.();
    };

    return (
        <>
            <Button
                ref={buttonRef}
                variant={isOpen ? 'lt-admin-contained' : 'lt-admin-outlined'}
                color={isOpen ? 'primary' : 'default'}
                aria-controls={isOpen ? menuId : undefined}
                aria-haspopup="true"
                aria-expanded={isOpen ? 'true' : undefined}
                {...(buttonProps || {})}
                onClick={handleOpen}
                sx={{ height: 40, ...(buttonProps?.sx || {}) }}
            >
                {label}
                {!hideChevron && (
                    <KeyboardArrowDownIcon
                        sx={{
                            ml: 'auto',
                            transition: 'transform 0.3s',
                            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                        }}
                    />
                )}
            </Button>
            <Menu
                id={menuId}
                anchorEl={buttonRef.current}
                open={isOpen}
                {...(menuProps || {})}
                onClose={handleClose}
                slotProps={{
                    ...(menuProps?.slotProps || {}),
                    paper: {
                        ...(menuProps?.slotProps?.paper || {}),
                        style: {
                            minWidth: menuHasButtonMinWidth
                                ? buttonRef.current?.offsetWidth
                                : menuProps?.slotProps?.paper?.style?.minWidth,
                            ...(menuProps?.slotProps?.paper?.style || {}),
                        },
                    },
                }}
            >
                {dropdownContent}
            </Menu>
        </>
    );
};

export default ButtonWithDropdownMenu;
